import { Pipe, PipeTransform } from '@angular/core';

import { SlimDocument } from '@app/models';

@Pipe({
  name: 'filterSigners',
  standalone: false
})
export class FilterSignersPipe implements PipeTransform {
  constructor() {}

  transform(options: { signers: SlimDocument['signatures'] }): SlimDocument['signatures'] {
    return options.signers?.filter(signer => signer.action);
  }
}
